export enum CharacterAnimationTypeEnum {
    Idle = 'idle',
    Attack = 'attack',
    Skill = 'skill',
    Hit = 'hit',
    Die = 'die'
}